import { ButtonIcon, Tooltip } from "pepsico-ds";
import React from "react";
import ChatListItem from "../../../ChatListItem/ChatListItem";
import { useAppDispatch } from "../../../../../hooks/app";
import { useNavigate, useParams } from "react-router-dom";
import { unFavouriteChat } from "../../../../../redux/reducers/chatFavourites/chatFavoriteReducer";
import { unwrapResult } from "@reduxjs/toolkit";
import { CloseOutRadioActions } from "../../../../../redux/closeoutslice/closeOutRadioSlice";
interface FavouriteListItemProps {
  chatId: string;
  sessionName: string;
  updatedDate: string;
}
function FavouriteListItem(props: FavouriteListItemProps) {
  const dispatch = useAppDispatch();
  const { chatId, sessionName, updatedDate } = props;
  const navigate = useNavigate();
  const params = useParams<{ sessionId: string }>();
  const { sessionId: urlSession } = params;
  const isActive = urlSession === chatId;
  const goToChatHandler = () => {
    navigate(`/spend-wise-hub/chat-assistant/${chatId}`);
  };
  const unFavouriteHandler = () => {
    dispatch(unFavouriteChat(chatId))
      .then(unwrapResult)
      .then(() => {
        dispatch(
          CloseOutRadioActions.setSnackBarMessage({
            message: "Chats removed from favorites successfully.",
            severity: "success",
          })
        );
      })
      .catch((error) => {
        dispatch(
          CloseOutRadioActions.setSnackBarMessage({
            message: "Failed to remove chat from favorites.",
            severity: "error",
          })
        );
      });
  };
  const more = (
    <Tooltip text="Remove from Favorites" direction="left">
      <ButtonIcon
        onClick={unFavouriteHandler}
        icon="star"
        size="large"
        style={{
          color: "#ffc01d",
        }}
      />
    </Tooltip>
  );
  return (
    <>
      <ChatListItem
        chatId={chatId}
        sessionName={sessionName}
        updatedDate={updatedDate}
        isActive={isActive}
        primaryAction={goToChatHandler}
        more={more}
      />
    </>
  );
}

export default FavouriteListItem;
